import {Typed} from "app/stimulus/typed-stimulus";
import {LiveComponentToolsController} from "app/stimulus/live-component-tools-controller";
import {Controller} from "@hotwired/stimulus";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";

@AsStimulusController('user-profile-verification-status')
export default class extends Typed(
    LiveComponentToolsController(Controller<HTMLElement>),
)
{
    public reloadPage(): void {
        window.location.reload();
    }
}
